<nav id="sitesFooter" class="navbar navbar-default navbar-fixed-bottom">
	<div class="container-fluid" style="margin-bottom: 0px">
		<ul class="nav navbar-nav navbar-left">
			<li>
				<a (click)="setScaleClicked.emit()" data-toggle="tooltip" title="" data-original-title="Set a scale for this location">
					<i class="fa fa-arrows-h"></i>
					<span> SCALE</span>
				</a>
			</li>
			<li>
				<a (click)="uploadMapClicked.emit()" data-toggle="tooltip" title="" data-original-title="Upload Your Map">
					<i class="fa fa-plus"></i>&nbsp;
					<i class="fa fa-file-image-o"></i>
					<span> MAP</span>
				</a>
			</li>
			<li>
				<a (click)="addZoneClicked.emit()" data-toggle="tooltip" title="" data-original-title="Draw Zone">
					<i class="fa fa-plus"></i>
					<span> ZONE</span>
				</a>
			</li>
			<li>
				<a (click)="addSubLocationClicked.emit()" data-toggle="tooltip" title="" data-original-title="Draw SubLocation">
					<i class="fa fa-plus"></i>&nbsp;
					<i class="fa fa-map"></i>
					<span> SUBLOCATION</span>
				</a>
			</li>
			<li>
				<a (click)="toggleTrackingClicked.emit()" data-toggle="tooltip" title="" data-original-title="Tracking On/Off">
					<i class="fa fa-paw"></i> 
					<span> TRACKING OFF</span>
				</a>
			</li>
		</ul>
	</div>
</nav>